function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Formik } from 'formik';
import { useMutation, useQuery } from '@apollo/client';
import { TEACHER_RACE_OPTIONS } from '@myap/metadata';
import { isEmpty } from '../../utilities';
import { teacherRegistrationMutation, teacherRegistrationQuery, saveTeacherRegistration } from './actions';
import TeacherRegistrationForm from './TeacherForm';
import { DEFAULT_TEACHER_VALUES, REQUIRED_TEACHER_VALUES, FIELD_RACE, FIELD_RECOGNIZED_TRIBE, FIELD_ENROLLED_TRIBE, FIELD_DESCENDANT_TRIBE } from './constants'; // configurable properities
// educationPeriodData (required, must be the education period object that contains at least
// selectedEducationPeriod, availableEducationPeriods, and selectedIsCurrent)
// onSaveSuccess (optional, is called when the registration was successfully saved)
// canSaveInitialValues  (optional, enable save button on load when all values are valid)

export default (function (_ref) {
  var client = _ref.client,
      onSaveSuccess = _ref.onSaveSuccess,
      educationPeriodData = _ref.educationPeriodData,
      personId = _ref.personId,
      _ref$isModal = _ref.isModal,
      isModal = _ref$isModal === void 0 ? false : _ref$isModal,
      _ref$canSaveInitialVa = _ref.canSaveInitialValues,
      canSaveInitialValues = _ref$canSaveInitialVa === void 0 ? false : _ref$canSaveInitialVa;
  var variables = {
    personId: personId,
    isProfessional: true
  };

  var _useMutation = useMutation(teacherRegistrationMutation, {
    client: client
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      update = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      saving = _useMutation2$.loading,
      mutationError = _useMutation2$.error;

  var _useQuery = useQuery(teacherRegistrationQuery, {
    variables: variables,
    client: client
  }),
      data = _useQuery.data,
      loading = _useQuery.loading,
      queryError = _useQuery.error;

  var _ref2 = data || {},
      _ref2$getTeacherRegis = _ref2.getTeacherRegistration,
      getTeacherRegistration = _ref2$getTeacherRegis === void 0 ? {} : _ref2$getTeacherRegis;

  var keys = getTeacherRegistration ? Object.keys(getTeacherRegistration) : [];

  var initialValues = _objectSpread(_objectSpread({}, DEFAULT_TEACHER_VALUES), keys.reduce(function (obj, key) {
    return !isEmpty(getTeacherRegistration[key]) ? _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, getTeacherRegistration[key])) : obj;
  }, {}));

  return /*#__PURE__*/React.createElement(Formik, {
    onSaveSuccess: onSaveSuccess,
    initialValues: initialValues,
    isInitialValid: canSaveInitialValues ? Object.keys(initialValues).every(function (key) {
      var value = initialValues[key];
      var hasValue = Array.isArray(value) ? value && value.length > 0 : value;
      return REQUIRED_TEACHER_VALUES[key] ? hasValue : true;
    }) && (Array.isArray(initialValues[FIELD_RACE]) && !initialValues[FIELD_RACE].find(function (v) {
      return v == TEACHER_RACE_OPTIONS.nativeAmerican.value;
    }) || Array.isArray(initialValues[FIELD_RACE]) && initialValues[FIELD_RACE].find(function (v) {
      return v == TEACHER_RACE_OPTIONS.nativeAmerican.value;
    }) && initialValues[FIELD_RECOGNIZED_TRIBE] !== null && (initialValues[FIELD_RECOGNIZED_TRIBE] && initialValues[FIELD_ENROLLED_TRIBE] !== null || initialValues[FIELD_RECOGNIZED_TRIBE] === false)) : false,
    validate: function validate(values) {
      var errors = {};

      if (Array.isArray(values[FIELD_RACE]) && values[FIELD_RACE].find(function (v) {
        return v == TEACHER_RACE_OPTIONS.nativeAmerican.value;
      }) && values[FIELD_RECOGNIZED_TRIBE] === null) {
        errors[FIELD_RECOGNIZED_TRIBE] = 'Field is required';
      }

      return errors;
    },
    enableReinitialize: true,
    onSubmit: /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, _ref3) {
        var setSubmitting, resetForm, setStatus, enrolledRecognizedTribeInd, enrolledTribeCd, descendantTribe, __typename, saveable, tribeFields, unsentTribeFields, _unsentTribeFields, updateObj, _yield$update, _data, savedUpdateObject;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setSubmitting = _ref3.setSubmitting, resetForm = _ref3.resetForm, setStatus = _ref3.setStatus;

                if (!saving) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                setStatus('');
                _context.prev = 4;
                enrolledRecognizedTribeInd = values[FIELD_RECOGNIZED_TRIBE], enrolledTribeCd = values[FIELD_ENROLLED_TRIBE], descendantTribe = values[FIELD_DESCENDANT_TRIBE], __typename = values.__typename, saveable = _objectWithoutProperties(values, [FIELD_RECOGNIZED_TRIBE, FIELD_ENROLLED_TRIBE, FIELD_DESCENDANT_TRIBE, "__typename"].map(_toPropertyKey)); // filter out UI only fields and Native American tribe fields
                // We don't want to include Native American tribe fields if raceCode 1 is not selected

                tribeFields = {};
                unsentTribeFields = {};

                if (Array.isArray(values[FIELD_RACE]) && values[FIELD_RACE].some(function (v) {
                  return v == TEACHER_RACE_OPTIONS.nativeAmerican.value;
                })) {
                  tribeFields = {
                    enrolledRecognizedTribeInd: enrolledRecognizedTribeInd,
                    enrolledTribeCd: enrolledTribeCd,
                    descendantTribe: descendantTribe
                  };
                } else {
                  unsentTribeFields = (_unsentTribeFields = {}, _defineProperty(_unsentTribeFields, FIELD_RECOGNIZED_TRIBE, null), _defineProperty(_unsentTribeFields, FIELD_ENROLLED_TRIBE, null), _defineProperty(_unsentTribeFields, FIELD_DESCENDANT_TRIBE, null), _unsentTribeFields);
                }

                updateObj = {
                  variables: _objectSpread(_objectSpread({}, variables), {}, {
                    input: _objectSpread(_objectSpread(_objectSpread({}, saveable), tribeFields), {}, {
                      educationPeriodCd: educationPeriodData.selectedEducationPeriod,
                      personId: personId
                    })
                  })
                };
                _context.next = 12;
                return update(updateObj);

              case 12:
                _yield$update = _context.sent;
                _data = _yield$update.data;
                savedUpdateObject = Object.keys(tribeFields).length > 0 ? _objectSpread(_objectSpread(_objectSpread({}, saveable), tribeFields), {}, {
                  educationPeriodCd: educationPeriodData.selectedEducationPeriod,
                  personId: personId
                }) : _objectSpread(_objectSpread(_objectSpread({}, saveable), unsentTribeFields), {}, {
                  educationPeriodCd: educationPeriodData.selectedEducationPeriod,
                  personId: personId
                });
                saveTeacherRegistration(client, variables, savedUpdateObject);
                resetForm(values);
                if (onSaveSuccess) onSaveSuccess(savedUpdateObject);
                _context.next = 25;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](4);
                setStatus('error');
                setSubmitting(false);
                console.error('Error saving teacher registration', _context.t0);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 20]]);
      }));

      return function (_x, _x2) {
        return _ref4.apply(this, arguments);
      };
    }(),
    component: function component(props) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TeacherRegistrationForm, _extends({}, props, {
        educationPeriodData: educationPeriodData,
        client: client,
        isLoading: loading,
        isModal: isModal,
        mutationErrors: mutationError,
        queryErrors: queryError
      })));
    }
  });
});